import { SEAT_MAP } from '../products';
import SeatMap from './components/SeatMap';
import SeatMapProductModal from './components/SeatMapProductModal';
import getIcon from './utils/icon';
import { getSelection, getMinPrice, isSelected, getPrice } from './utils/selection';
import { getGraphQlSelection } from './utils/getGraphQlSelection';
import { getData, transformSeatmapPrices } from './utils/seatMapTransformer';
import { getTravelers } from './utils/seatMapProductModalUtils';
import { seatingPreferenceValues } from './constants/seatingPreferenceValues';
const formSection = SEAT_MAP.name;
const seatMap = {
  getGraphQlSelection,
  getIcon,
  getMinPrice,
  getPrice: form => state => getPrice(formSection, form)(state).price,
  getMarkup: form => state => getPrice(formSection, form)(state).markup,
  getSelection: getSelection.bind(null, formSection),
  isSelected: isSelected.bind(null, formSection),
  formSection,
  seatingPreferenceValues,
  getTravelers,
  getData,
  transformSeatmapPrices,
  ...SEAT_MAP
};
export { seatMap, SeatMap, SeatMapProductModal };
//# sourceMappingURL=index.js.map